import styled, { css } from 'styled-components';

export const ChangeDomainWrapper = styled.div`
  ${({ theme, $centered }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: ${$centered ? 'center' : 'flex-start'};
    min-height: 100%;
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    max-width: fit-content;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px 20px;
      width: calc(100% - 40px);
    }
  `}
`;

export const LogoRow = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highLight};
    display: flex;
    justify-content: center;
    padding: 20px 0;
  `}
`;

export const Breadcrumbs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-start;
`;

export const BreadcrumbItem = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px 4px;
    text-decoration: underline;
    display: flex;
    align-item: center;

    &:last-child {
      font-weight: ${theme.v2.font.weights.regular};
      text-decoration: unset;
      color: ${theme.v2.colors.neutral.lowMedium};
    }
  `}
`;

export const SkeletonWrapper = styled(ChangeDomainWrapper)`
  ${({ theme }) => css`
    gap: 0;
    width: 738px;

    @media(max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px 20px;
      width: calc(100% - 40px);
    }
  `};
`;

export const TopContent = styled.div`
  align-items: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  width: 100%;

  & > :first-child {
    margin-bottom: 40px;
  }
`;

export const BottomContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 48px;
  width: 100%;
`;
